export const GLOBAL_STATE = 'Level'

export const LEVEL = 'level'
export const LEVEL_LIST = 'levelList'
export const LEVEL_ALL = 'levelAll'
export const LEVEL_CREATE = 'levelCreate'
